import { isExpressionValue } from '@shared/helpers/expression-factory.helpers';
import {
  solve,
  SolveBoundViolation,
} from '@shared/helpers/expression-solving.helpers';
import type { ExpressionVariables } from '@shared/helpers/expression-variables.helpers';
import { ElementPropertyType } from '@shared/models/element-property.model';
import type { ExpressionValue } from '@shared/models/project.model';
import { contentCoverageProperty } from '@shared/templates/categories/common-element-category-properties.model';

/**
 * Message when a content-coverage count solves outside its min/max.
 * The displayed number can stay at the last in-range override, so the slider
 * still needs this text for the error tooltip.
 * @param count - Stored count or fallback
 * @param variables - Symbols in scope for the formula
 */
export const contentCoverageBoundErrorMessage = (
  count: ExpressionValue | undefined,
  variables?: ExpressionVariables,
): string | undefined => {
  if (!isExpressionValue(count)) return undefined;
  if (contentCoverageProperty.type !== ElementPropertyType.Expression) {
    return undefined;
  }

  try {
    solve(count.value, count.expression, variables, {
      min: contentCoverageProperty.min,
      max: contentCoverageProperty.max,
    });
    return undefined;
  } catch (error) {
    return error instanceof SolveBoundViolation ? error.message : undefined;
  }
};
